import {
  FONT_SIZE_24,
  FONT_SIZE_12,
  FONT_SIZE_10,
  PRIMARY_TEXT,
  CATSKILL_WHITE,
  TERTIARY_ACCENT,
} from '../../pdf_styles';

const PdfStyles = {
  logo: {
    height: 24,
    width: 'auto',
  },
  header: {
    alignItems: 'center',
    backgroundColor: CATSKILL_WHITE,
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontSize: FONT_SIZE_12,
    marginBottom: 20,
    marginHorizontal: -35,
    padding: 35,
    color: PRIMARY_TEXT,
  },
  headerBrand: {
    alignItems: 'center',
    fontSize: FONT_SIZE_24,
    flexDirection: 'row',
  },
  headerInfo: {
    lineHeight: 1.5,
  },
  company: {
    fontSize: FONT_SIZE_12,
  },
  address: {
    fontSize: FONT_SIZE_10,
  },
  vat: {
    fontSize: FONT_SIZE_10,
  },
  footer: {
    alignItems: 'center',
    backgroundColor: TERTIARY_ACCENT,
    color: 'white',
    flexDirection: 'row',
    justifyContent: 'space-between',
    position: 'absolute',
    fontSize: FONT_SIZE_10,
    bottom: 0,
    left: 0,
    right: 0,
    padding: 15,
    paddingHorizontal: '35',
  },
  subFooter: {
    fontSize: FONT_SIZE_10,
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '40vw',
  },
};

export default PdfStyles;
